import axiosInstance from '@/utils/api.js'

var state = {
  ISGattributes: [],
  customTSGattributes: []
}

var getters = {
  ISG_ATTRIBUTES: (state) => {
    return state.ISGattributes
  },
  CUSTOM_ISG_ATTRIBUTES: (state) => {
    return state.customTSGattributes
  }
}

var mutations = {
  SET_ISG_ATTRIBUTES: (state, payload) => {
    state.ISGattributes = payload
  },
  SET_CUSTOM_ISG_ATTRIBUTES: (state, payload) => {
    state.customTSGattributes = payload
  }
}

var actions = {
  GET_ISG_ATTRIBUTES: async (context, payload) => {
    let result = await axiosInstance.get('/settings/isg_attrs')
    if (result.status === 200) {
      context.commit('SET_ISG_ATTRIBUTES', result.data)
    }
  },
  CREATE_ISG_ATTRIBUTES: (context, payload) => {
    return axiosInstance.post('/settings/isg_attrs', payload)
  },
  UPDATE_ISG_ATTRIBUTES: (context, payload) => {
    return axiosInstance.put('/settings/isg_attrs', payload)
  },
  DELETE_ISG_ATTRIBUTES: (context, payload) => {
    return axiosInstance.delete('/settings/isg_attrs?isg_attr_id=' + payload)
  },
  GET_CUSTOM_ISG_ATTRIBUTES: async (context, payload) => {
    let result = await axiosInstance.get('/settings/custom_isg_attrs')
    if (result.status === 200) {
      context.commit('SET_CUSTOM_ISG_ATTRIBUTES', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/ISGattributes.js